import i18n from "../../i18n";

export const emailValidator = (value) =>
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)
    ? null
    : i18n.t("validation.invalidEmail");

export const requiredValidator = (value) =>
  value && value.trim() !== "" ? null : i18n.t("validation.required");
